import Guardian from "../animations/guardians/Guardian";
import GuardianElf from "../animations/guardians/GuardianElf";
import GuardianElfFemale from "../animations/guardians/GuardianElfFemale";
import GuardianKnight from "../animations/guardians/GuardianKnight";
import GuardianKnightFemale from "../animations/guardians/GuardianKnightFemale";
import GuardianRanger from "../animations/guardians/GuardianRanger";
import GuardianRangerFemale from "../animations/guardians/GuardianRangerFemale";
import GuardianWarrior from "../animations/guardians/GuardianWarrior";
import GuardianWitch from "../animations/guardians/GuardianWitch";
import GuardianWizard from "../animations/guardians/GuardianWizard";
import Pet from "../animations/pets/Pet";
import PetBat from "../animations/pets/PetBat";
import PetDragon from "../animations/pets/PetDragon";
import PetOwl from "../animations/pets/PetOwl";
import PetRaven from "../animations/pets/PetRaven";
import common from "../common";
import CharacterSelector from "../ui/CharacterSelector";
import GelButton from "../ui/gel/GelButton";
import GelHackButton from "../ui/gel/GelHackButton";
import GelScene from "../ui/gel/GelScene";
import LocationSelector from "../ui/LocationSelector";

export default class OverviewScene extends GelScene {
    constructor(finishedTraining = false, gotoPage = null, weaponReveal = false) {
        super();

        this._data = null;
        this._camera = null;

        this._backgroundLayer = null;
        this._mainLayer = null;
        this._particleLayer = null;

        this._characterInfo = null;
        this._characterButton = null;
        this._characterSelector = null;
        this._locationSelector = null;

        this._lastCharacterType = "";

        this._editCharacter = !finishedTraining || !!gotoPage;
        this._finishedTraining = finishedTraining;
        this._gotoPage = gotoPage;
        this._weaponReveal = weaponReveal;
        this._layoutTweens = new P3.utils.TWEEN.Group();

        this._cameraLeft = -260;
        this._cameraRight = 300;

        this._ambienceAudio = null;
        this._equipEmitter = null;
        this._characterEmitter = null;
        this._fairyDustEmitter = null;

        this._weeklyChallengeVO = null;
    }

    init() {
        super.init();

        this._data = common.save.getUserData(common.userId);

        this._camera = new P3.NewCamera();

        this._backgroundLayer = new PIXI.Container();
        this.addChild(this._backgroundLayer);

        this._mainLayer = new PIXI.Container();
        this.addChild(this._mainLayer);

        this._camera.addLayer(new P3.CameraLayer(this._backgroundLayer, new PIXI.Point(0.1, 1)));
        this._camera.addLayer(new P3.CameraLayer(this._mainLayer, new PIXI.Point(1, 1)));

        this._camera.setTarget(new PIXI.Point(this._editCharacter ? this._cameraLeft : this._cameraRight));

        this.initBackButton(GelButton.TAB_INDEX_LEVEL_0);
        this.initAchievementsButton(GelButton.TAB_INDEX_LEVEL_0 + 1);
        this.initMuteButton(GelButton.TAB_INDEX_LEVEL_0 + 2);
        this.initSettingsButton(GelButton.TAB_INDEX_LEVEL_0 + 3);
        this.initNextButton(GelButton.TAB_INDEX_LEVEL_3, GelButton.POSITION_BOTTOM_RIGHT);

        this.initScene();
        this.initCharacterInfo();
        this.initCharacterButton();
        this.initCharacterSelector();
        this.initProgressBar();
        this.initLocationSelector();
        this.initTitle("Choose Battle");

        this._particleLayer = new PIXI.Container();
        this._mainLayer.addChild(this._particleLayer);

        let config = P3.assets.json("particle_equip_character_0");
        this._equipEmitter = new PIXI.particles.Emitter(this._particleLayer, [
            P3.assets.texture("particle_divide"),
            P3.assets.texture("particle_minus"),
            P3.assets.texture("particle_multiply"),
            P3.assets.texture("particle_plus"),
            P3.assets.texture("particle_shape1"),
            P3.assets.texture("particle_shape2"),
            P3.assets.texture("particle_shape3"),
            P3.assets.texture("particle_shape4")
        ], config);

        this._equipEmitter.updateOwnerPos(this._characterInfo.x, this._characterInfo.y - 180);
        this._equipEmitter.emit = false;

        config = P3.assets.json("particle_change_character_0");
        this._characterEmitter = new PIXI.particles.Emitter(this._particleLayer, [
            P3.assets.texture("particle_divide"),
            P3.assets.texture("particle_minus"),
            P3.assets.texture("particle_multiply"),
            P3.assets.texture("particle_plus"),
            P3.assets.texture("particle_shape1"),
            P3.assets.texture("particle_shape2"),
            P3.assets.texture("particle_shape3"),
            P3.assets.texture("particle_shape4")
        ], config);

        this._characterEmitter.updateOwnerPos(this._characterInfo.x, this._characterInfo.y - 180);
        this._characterEmitter.emit = false;

        config = P3.assets.json("particle_fairy_dust");
        this._fairyDustEmitter = new PIXI.particles.Emitter(this._backgroundLayer, [
            P3.assets.texture("particle_divide"),
            P3.assets.texture("particle_minus"),
            P3.assets.texture("particle_multiply"),
            P3.assets.texture("particle_plus")
        ], config);

        this._fairyDustEmitter.emit = true;
        this._fairyDustEmitter.updateOwnerPos(0, 0);

        this._title.visible = !this._editCharacter;

        const states = this._nextButton.states;
        states.icon = P3.assets.texture(this._editCharacter ? "btn_icon_next_large" : "btn_icon_play_large");
        this._nextButton.setStates(states);

        // stats
        if (!this._gotoPage)
        {
            common.gmi.setStatsScreen && common.gmi.setStatsScreen("battlecards");
        }
        else
        {
            if (this._gotoPage.type === OverviewScene.PAGE_CHARACTER || this._gotoPage.type === OverviewScene.PAGE_ITEM)
            {
                common.gmi.setStatsScreen && common.gmi.setStatsScreen("editcharacter");
            }
        }
    }

    destroy() {
        this._equipEmitter.destroy();
        this._characterEmitter.destroy();
        this._fairyDustEmitter.destroy();
        this._characterInfo.orbBanner.emitter.destroy();

        if (this._weeklyChallengeVO)
        {
            this._weeklyChallengeVO.destroy();
            this._weeklyChallengeVO = null;
        }

        super.destroy();
    }

    resize() {
        super.resize();

        this._fairyDustEmitter.spawnRect = new PIXI.Rectangle(0, 0, this._backgroundLayer.width, P3.View.height);
    }

    show() {
        super.show();

        this.setAllButtonsEnabled(true);

        this._nextButton.interactive = true;

        this.playAmbienceSFX();
    }

    hide() {
        super.hide();

        this._nextButton.interactive = true;

        this.stopAmbienceSFX();
    }

    appear() {
        super.appear();

        if (this._weaponReveal)
        {
            const user = common.save.getUserData(common.userId);
            if (user.orbs <= 1)
            {
                P3.audio.playVO("vo_queen_extra_0608", 1, true);
            }
            else
            {
                P3.audio.playVO("vo_queen_extra_09b1", 1, true);
            }
        }
        else if (this._finishedTraining)
        {
            !this._gotoPage && this.playBattlecardsDiscoveredVO();
        }
        else
        {
            P3.audio.playVO("vo_queen_07b", 1, true);
        }

        if (this._weaponReveal)
        {
            this._characterInfo.animation.playWeaponRevealAnim();

            this._characterInfo.orbBanner.spine.state.setAnimation(0, "glow", false);
            this._characterInfo.orbBanner.spine.state.addAnimation(0, "default", true, 0);
        }
    }

    animateIn(callback, scope) {
    }

    update() {
        super.update();

        const dt = window.dt;
        this._camera.update();
        this._locationSelector.update(dt);
        this._characterSelector.update(dt);

        const settings = common.gmi.getAllSettings();
        if (settings.motion) {
            this._characterInfo.animation && this._characterInfo.animation.update(dt);
            this._characterInfo.petAnimation && this._characterInfo.petAnimation.update(dt);
        }

        this._layoutTweens.update();

        if (settings.motion) {
            this._equipEmitter.update(dt);
            this._characterEmitter.update(dt);
            this._fairyDustEmitter.update(dt);

            this._characterInfo.orbBanner.spine.update(dt);
            this._characterInfo.orbBanner.emitter.update(dt);

            this._characterInfo.animation.emitter.update(dt);

            const attachment = this._characterInfo.animation.spine.skeleton.findSlot("object_right");
            const local = this._characterInfo.toLocal(
                new PIXI.Point(attachment.currentSprite.position.x, attachment.currentSprite.position.y), attachment.currentSprite.parent);

            this._characterInfo.animation.emitter.updateOwnerPos(local.x, local.y);
        }
    }

    gotoItemPage(slot, type) {
        if (!this._editCharacter) return;
        this._characterSelector.gotoItemPage(slot, type);
    }

    initScene() {
        const background = new PIXI.Sprite(P3.assets.texture("env_bg_char_select"));
        background.width = common.STAGE_WIDTH;
        this._backgroundLayer.addChild(background);

        const island = new PIXI.Sprite(P3.assets.texture("character_island_0"));
        island.position.set(common.STAGE_WIDTH * 0.5, 670);
        island.anchor.set(0.5);
        this._mainLayer.addChild(island);
    }

    initCharacterInfo() {
        this._characterInfo = new PIXI.Container();
        this._characterInfo.position.set(common.STAGE_WIDTH * 0.5, 600);
        this._mainLayer.addChild(this._characterInfo);

        this.initOrbBanner();
        this.initPetAnimation();
        this.initCharacterAnimation();

        this._characterInfo.nameLabel = new PIXI.extras.BitmapText(common.character.name, {font: "32px Carter One"});
        this._characterInfo.nameLabel.anchor.set(0.5);
        this._characterInfo.addChild(this._characterInfo.nameLabel);

        if (common.save.isWeeklyChallengeComplete(common.userId))
        {
            this._characterInfo.nameLabel.position.set(80, -424);
        }
        else
        {
            this._characterInfo.nameLabel.position.set(12, -424);
        }
    }

    initCharacterAnimation() {
        this._characterInfo.animation && this._characterInfo.animation.destroy();
        this._characterInfo.animation = null;

        const golden = !this._weaponReveal && common.save.isWeeklyChallengeComplete(common.userId);

        const user = common.save.getUserData(common.userId);
        switch (common.character.type) {
            default :
            case Guardian.TYPE_ELF : {
                this._characterInfo.animation = new GuardianElf(golden);
                break;
            }
            case Guardian.TYPE_ELF_FEMALE : {
                this._characterInfo.animation = new GuardianElfFemale(golden);
                break;
            }
            case Guardian.TYPE_KNIGHT : {
                this._characterInfo.animation = new GuardianKnight(golden);
                break;
            }
            case Guardian.TYPE_KNIGHT_FEMALE : {
                this._characterInfo.animation = new GuardianKnightFemale(golden);
                break;
            }
            case Guardian.TYPE_RANGER : {
                this._characterInfo.animation = new GuardianRanger(golden);
                break;
            }
            case Guardian.TYPE_RANGER_FEMALE : {
                this._characterInfo.animation = new GuardianRangerFemale(golden);
                break;
            }
            case Guardian.TYPE_WARRIOR : {
                this._characterInfo.animation = new GuardianWarrior(golden);
                break;
            }
            case Guardian.TYPE_WIZARD : {
                this._characterInfo.animation = new GuardianWizard(golden);
                break;
            }
            case Guardian.TYPE_WITCH : {
                this._characterInfo.animation = new GuardianWitch(golden);
                break;
            }
        }

        if (common.save.isWeeklyChallengeComplete(common.userId))
        {
            this._characterInfo.animation.position.set(60, 0);
        }

        this._characterInfo.animation.scale.set(0.4);
        this._characterInfo.animation.init(user.class);
        this._characterInfo.addChild(this._characterInfo.animation);

        this._characterInfo.animation.playIdleAnim();
        this._characterInfo.animation.update(0);

        const config = P3.assets.json("particle_weapon_reveal_0");
        this._characterInfo.animation.emitter = new PIXI.particles.Emitter(this._characterInfo, [
            P3.assets.texture("particle_divide"),
            P3.assets.texture("particle_minus"),
            P3.assets.texture("particle_multiply"),
            P3.assets.texture("particle_plus"),
            P3.assets.texture("particle_shape1"),
            P3.assets.texture("particle_shape2"),
            P3.assets.texture("particle_shape3"),
            P3.assets.texture("particle_shape4"),
        ], config);
        this._characterInfo.animation.emitter.emit = false;

        this._characterInfo.animation.spine.state.addListener({
            event: (entry, event) =>
            {
                switch (event.stringValue)
                {
                    case "weapon_reveal":
                    {
                        this._characterInfo.animation.emitter.emit = true;
                        break;
                    }
                }
            }
        });

        for (const i in user.equipment) {
            if (user.equipment.hasOwnProperty(i)) {
                const type = user.equipment[i];
                if (i !== "pet") {
                    this._characterInfo.animation.setItem(i, type);
                }
            }
        }
    }

    initPetAnimation() {
        this._characterInfo.petAnimation && this._characterInfo.petAnimation.destroy();
        this._characterInfo.petAnimation = null;

        const type = common.save.getUserPetId(common.userId);
        if (type !== -1) {
            switch (type) {
                default :
                case Pet.TYPE_OWL : {
                    this._characterInfo.petAnimation = new PetOwl();
                    break;
                }
                case Pet.TYPE_BAT : {
                    this._characterInfo.petAnimation = new PetBat();
                    break;
                }
                case Pet.TYPE_DRAGON : {
                    this._characterInfo.petAnimation = new PetDragon();
                    break;
                }
                case Pet.TYPE_RAVEN : {
                    this._characterInfo.petAnimation = new PetRaven();
                    break;
                }
            }

            if (common.save.isWeeklyChallengeComplete(common.userId))
            {
                this._characterInfo.petAnimation.position.set(60, 0);
            }

            this._characterInfo.petAnimation.scale.set(0.4);
            this._characterInfo.petAnimation.init();
            this._characterInfo.addChild(this._characterInfo.petAnimation);

            this._characterInfo.petAnimation.playIdleAnim();
            this._characterInfo.petAnimation.update(0);

            const settings = common.gmi.getAllSettings();
            if (settings.motion) {
                this._characterInfo.petAnimation.scale.set(0);
                new P3.utils.TWEEN.Tween(this._characterInfo.petAnimation.scale, this._tweens)
                    .to({x: 0.4, y: 0.4}, 440)
                    .easing(P3.utils.TWEEN.Easing.Cubic.Out)
                    .start();
            }
        }
    }

    initOrbBanner()
    {
        const user = common.save.getUserData(common.userId);

        this._characterInfo.orbBanner = new PIXI.Container();
        this._characterInfo.orbBanner.position.set(-84, 8);
        this._characterInfo.addChild(this._characterInfo.orbBanner);

        this._characterInfo.orbBanner.spine = new PIXI.spine.Spine(P3.assets.spineData("challenge_flag"));
        this._characterInfo.orbBanner.spine.autoUpdate = false;
        this._characterInfo.orbBanner.spine.skeleton.setSkin(null);
        this._characterInfo.orbBanner.spine.stateData.defaultMix = 0.2;
        this._characterInfo.orbBanner.spine.update();
        this._characterInfo.orbBanner.addChild(this._characterInfo.orbBanner.spine);

        this._characterInfo.orbBanner.text = new PIXI.extras.BitmapText(user.orbs + "", {font: 42 + "px BBC Reith Sans", align: "center"});
        this._characterInfo.orbBanner.text.position.set(-6, -334);
        this._characterInfo.orbBanner.text.anchor.set(0.5);
        this._characterInfo.orbBanner.text.tint = 0x02057C;
        this._characterInfo.orbBanner.addChild(this._characterInfo.orbBanner.text);

        this._characterInfo.orbBanner.particles = new PIXI.Container();
        this._characterInfo.orbBanner.particles.position.set(-6, -334);
        this._characterInfo.orbBanner.addChildAt(this._characterInfo.orbBanner.particles, 0);

        const config = P3.assets.json("particle_orb");
        this._characterInfo.orbBanner.emitter = new PIXI.particles.Emitter(this._characterInfo.orbBanner.particles, [
            P3.assets.texture("particle_orb"),
        ], config);

        this._characterInfo.orbBanner.spine.state.setAnimation(0, "default", true);

        if (!common.save.isWeeklyChallengeComplete(common.userId))
        {
            this._characterInfo.orbBanner.visible = false;
        }
    }

    initCharacterButton() {
        this._characterButton = GelHackButton.create(
            P3.assets.texture("btn_char_info_normal"),
            P3.assets.texture("ui_btn_char_info_over"),
            P3.assets.texture("ui_btn_char_info_down"),
        );
        this._characterButton.position.set(this._characterInfo.x, this._characterInfo.y - 140);
        this._characterButton.animate = false;
        this._characterButton.animateIcon = false;
        this._characterButton.visible = !this._editCharacter;
        this._characterButton.overSoundName = "sfx_btn_rollover_00";
        this._characterButton.clickSoundName = "sfx_btn_press_00";
        this._characterButton.voSoundName = "vo_queen_119b";
        this._characterButton.tabIndex = GelButton.TAB_INDEX_LEVEL_1;
        this._characterButton.signals.click.add(this.onCharacterButtonClick, this);
        this._mainLayer.addChild(this._characterButton);

        this._characterButton.label = new PIXI.extras.BitmapText("Edit Character", {font: "26px BBC Reith Sans"});
        this._characterButton.label.position.set(26, 178);
        this._characterButton.label.anchor.set(0.5);
        this._characterButton.label.tint = 0xFFFFFF;
        this._characterButton.animation.addChild(this._characterButton.label);
    }

    initProgressBar() {
        const user = common.save.getUserData(common.userId);
        const progression = P3.utils.objectToArray(common.config.game.level_progression);
        const target = progression[Math.min(progression.length - 1, user.level)];
        const to = user.xp / target;

        this._progress = new PIXI.Sprite(P3.assets.texture("progress/ui_xp_bg_small"));
        this._progress.position.set(this._characterButton.x, 714);
        this._progress.anchor.set(0.5);
        this._progress.visible = !this._editCharacter;
        this._mainLayer.addChild(this._progress);

        this._progress.fill = new PIXI.Sprite(P3.assets.texture("progress/ui_xp_fill_small"));
        this._progress.fill.anchor.set(0.5);
        this._progress.addChild(this._progress.fill);

        const width = this._progress.fill.texture.width;
        const height = this._progress.fill.texture.height;

        this._progress.fill.mask = new PIXI.Graphics();
        this._progress.fill.mask.position.set(-width * 0.5, 0);
        this._progress.fill.mask.scale.x = to;
        this._progress.fill.mask.beginFill(0xFF0000, 1);
        this._progress.fill.mask.drawRect(0, -height * 0.5, width, height);
        this._progress.fill.mask.endFill();
        this._progress.fill.addChild(this._progress.fill.mask);

        this._progress.plaque = new PIXI.Sprite(P3.assets.texture("progress/ui_xp_count_bg_small"));
        this._progress.plaque.position.set(-this._progress.texture.width * 0.5 - 40, 0);
        this._progress.plaque.anchor.set(0.5);
        this._progress.addChild(this._progress.plaque);

        this._progress.icon = new PIXI.Sprite(P3.assets.texture("progress/ui_xp_loot_small"));
        this._progress.icon.position.set(this._progress.texture.width * 0.5 + 36, 0);
        this._progress.icon.anchor.set(0.5);
        this._progress.addChild(this._progress.icon);

        let xp = Math.round(user.totalXp);
        let size = 30;
        if (xp > common.config.game.xp_cap) {
            xp = Math.round(common.config.game.xp_cap) + "+";
            size = 26;
        }

        this._progress.xpLabel = new PIXI.extras.BitmapText(xp + "", {font: size + "px BBC Reith Sans", align: "center"});
        this._progress.xpLabel.position.set(0, 14);
        this._progress.xpLabel.anchor.set(0.5);
        this._progress.xpLabel.tint = 0x390307;
        this._progress.plaque.addChild(this._progress.xpLabel);
    }

    initCharacterSelector() {
        let mode = CharacterSelector.MODE_CHARACTER;
        if (this._gotoPage)
        {
            if (this._gotoPage.type === OverviewScene.PAGE_ITEM)
            {
                mode = CharacterSelector.MODE_ITEM;
            }
        }

        this._characterSelector = new CharacterSelector(mode);
        this._characterSelector.position.set(common.STAGE_WIDTH * 0.5 - 200, 430);
        this._characterSelector.filters = [new PIXI.filters.AlphaFilter(this._editCharacter)];
        this._characterSelector.visible = this._editCharacter;
        this._characterSelector.disableInput(!this._editCharacter);
        this._characterSelector.signals.character.add(this.onCharacterSelectorSelect, this);
        this._characterSelector.signals.item.add(this.onCharacterSelectorItem, this);
        this.addChild(this._characterSelector);

        if (this._gotoPage)
        {
            if (mode === CharacterSelector.MODE_ITEM && this._gotoPage.item)
            {
                this.gotoItemPage(this._gotoPage.item.slot, this._gotoPage.item.type);
            }
        }
    }

    initLocationSelector() {
        this._locationSelector = new LocationSelector(this._finishedTraining);
        this._locationSelector.position.set(common.STAGE_WIDTH * 0.5 + 180, 386);
        this._locationSelector.filters = [new PIXI.filters.AlphaFilter(!this._editCharacter)];
        this._locationSelector.visible = !this._editCharacter;
        this._locationSelector.scrollTo(common.locationIndex);
        this._locationSelector.signals.select.add(this.onLocationSelectorSelect, this);
        this.addChild(this._locationSelector);
    }

    setCharacter(skin) {
        console.log("*" + skin);

        const user = common.save.getUserData(common.userId);
        user.class = skin;
        common.save.saveGame();

        this._characterEmitter.emit = true;

        const characters = P3.utils.objectToArray(P3.assets.json("characters"));
        common.character = characters.filter(x => x.skin === user.class)[0];

        this.initCharacterAnimation();

        if (common.character.group !== this._lastCharacterType) {
            this._lastCharacterType = common.character.group;
            P3.audio.playVO(common.character.audio.name);
        } else {
            this._characterInfo.animation.setSkin(user.class);
        }

        // tracking
        common.gmi.sendStatsEvent("select_character", "click", {
            metadata: "AVA=" + user.class
        });
    }

    setItem(name, type) {
        const user = common.save.getUserData(common.userId);

        if (!Array.isArray(name)) {
            name = [name];
        }

        this._equipEmitter.emit = true;

        for (let i = 0; i < name.length; ++i) {
            const slotName = name[i];
            type = user.equipment[slotName] !== type ? type : 0;
            user.equipment[slotName] = type;

            if (slotName !== "pet") {
                this._characterInfo.animation.setItem(slotName, type);
                const settings = common.gmi.getAllSettings();

                !settings.motion && this._characterInfo.animation.reset();
            } else {
                this.initPetAnimation();
            }
        }
        common.save.saveGame();

        // tracking
        common.gmi.sendStatsEvent("item", "click");
    }

    showLocationSelector(delay = 0, callback, scope) {
        const filter = this._locationSelector.filters[0];
        new P3.utils.TWEEN.Tween(filter, this._layoutTweens)
            .to({alpha: 1}, 180)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .delay(delay)
            .onStart(() => {
                this._locationSelector.visible = true;
            })
            .onComplete(() => {
                callback && callback.call(scope);
            })
            .start();
    }

    hideLocationSelector(delay = 0, callback, scope) {
        const filter = this._locationSelector.filters[0];
        new P3.utils.TWEEN.Tween(filter, this._layoutTweens)
            .to({alpha: 0}, 180)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onComplete(() => {
                this._locationSelector.visible = false;
                callback && callback.call(scope);
            })
            .start();
    }

    showCharacterSelector(delay = 0, callback, scope) {
        const filter = this._characterSelector.filters[0];
        new P3.utils.TWEEN.Tween(filter, this._layoutTweens)
            .to({alpha: 1}, 180)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .delay(delay)
            .onStart(() => {
                this._characterSelector.visible = true;
            })
            .onComplete(() => {
                callback && callback.call(scope);
            })
            .start();
    }

    hideCharacterSelector(delay = 0, callback, scope) {
        const filter = this._characterSelector.filters[0];
        new P3.utils.TWEEN.Tween(filter, this._layoutTweens)
            .to({alpha: 0}, 180)
            .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
            .onComplete(() => {
                this._characterSelector.visible = false;
                callback && callback.call(scope);
            })
            .start();
    }

    switchLayout() {
        this._layoutTweens.removeAll();

        if (this._editCharacter) {
            this._editCharacter = false;
            this._characterButton.interactive = true;
            this._nextButton.voSoundName = "vo_queen_103a";

            this._finishedTraining && this.playBattlecardsDiscoveredVO();

            console.log("lock");

            const states = this._nextButton.states;
            states.icon = P3.assets.texture("btn_icon_play_large");
            this._nextButton.setStates(states);

            this._locationSelector.disableInput(false);
            this._characterSelector.disableInput(true);

            new P3.utils.TWEEN.Tween(this._camera.target, this._layoutTweens)
                .to({x: this._cameraRight}, 640)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .start();

            new P3.utils.TWEEN.Tween(this._title, this._layoutTweens)
                .to({alpha: 1}, 200)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .delay(240)
                .onStart(() => {
                    this._title.visible = true;
                })
                .start();

            new P3.utils.TWEEN.Tween(this._characterButton, this._layoutTweens)
                .to({alpha: 1}, 200)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .delay(240)
                .onStart(() => {
                    this._characterButton.visible = true;
                    this._characterButton.enabled = true;
                })
                .start();

            new P3.utils.TWEEN.Tween(this._progress, this._layoutTweens)
                .to({alpha: 1}, 200)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .delay(240)
                .onStart(() => {
                    this._progress.visible = true;
                })
                .start();

            this.showLocationSelector(320);
            this.hideCharacterSelector();

            P3.audio.playSound("sfx_customise_open_00");

            // if we have finished training - compliment character choice
            if (this._finishedTraining) {
                P3.audio.playVO(Math.random() < 0.4 ? common.character.audio.select : [
                    "vo_queen_27d",
                    "vo_queen_28a",
                    "vo_queen_29c",
                    "vo_queen_30c",
                    "vo_queen_31b",
                    "vo_queen_32a",
                    "vo_queen_33a",
                    "vo_queen_34",
                    "vo_queen_35b"
                ]);
            } else {
                P3.audio.playVO("vo_queen_56", 1, true);
            }

            // stats
            common.gmi.setStatsScreen && common.gmi.setStatsScreen("battlecards");
        } else {
            this._editCharacter = true;
            this._characterButton.interactive = false;
            this._nextButton.voSoundName = "vo_queen_114c";

            console.log("unlock");

            const states = this._nextButton.states;
            states.icon = P3.assets.texture("btn_icon_next_large");
            this._nextButton.setStates(states);

            this._locationSelector.disableInput(true);
            this._characterSelector.disableInput(false);

            new P3.utils.TWEEN.Tween(this._camera.target, this._layoutTweens)
                .to({x: this._cameraLeft}, 640)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .start();

            new P3.utils.TWEEN.Tween(this._title, this._layoutTweens)
                .to({alpha: 0}, 200)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onComplete(() => {
                    this._title.visible = false;
                })
                .start();

            new P3.utils.TWEEN.Tween(this._characterButton, this._layoutTweens)
                .to({alpha: 0}, 200)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onComplete(() => {
                    this._characterButton.visible = false;
                })
                .start();

            new P3.utils.TWEEN.Tween(this._progress, this._layoutTweens)
                .to({alpha: 0}, 200)
                .easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
                .onComplete(() => {
                    this._progress.visible = false;
                })
                .start();

            this.hideLocationSelector();
            this.showCharacterSelector(320);

            P3.audio.playSound("sfx_customise_close_00");

            // stats
            common.gmi.setStatsScreen && common.gmi.setStatsScreen("editcharacter");
        }
    }

    playAmbienceSFX() {
        this.stopAmbienceSFX();
        this._ambienceAudio = P3.audio.playSound("sfx_avatar_loop_ambience_01", {loop: true});
    }

    stopAmbienceSFX() {
        if (this._ambienceAudio) {
            this._ambienceAudio.stop();
            this._ambienceAudio = null;
        }
    }

    playBattlecardsDiscoveredVO() {
        const user = common.save.getUserData(common.userId);
        if (!user.battlecardsLearned) {
            user.battlecardsLearned = true;
            common.save.saveGame();

            P3.audio.playVO("vo_queen_40c", 1, true);
        }
        else if (common.location.challenge)
        {
            this.playWeeklyChallengeVO();
        }
    }

    onCharacterButtonClick(button) {
        this._characterButton.enabled = false;

        this.switchLayout();

        // tracking
        common.gmi.sendStatsEvent("edit_character", "click");
    }

    onNextButtonClick(button) {
        if (this._editCharacter) {
            this.switchLayout();
        } else {
            this.setAllButtonsEnabled(false);
            this.signals.next.dispatch(this, common.location.training);

            // tracking
            //common.gmi.sendStatsEvent("play", "click");   This was moved to the splash
        }
    }

    onLocationSelectorSelect(selector, id, index) {
        common.locationIndex = index;
        const locations = P3.utils.objectToArray(P3.assets.json("locations")).filter(x => x.id === id);
        common.location = locations[0];

        const user = common.save.getUserData(common.userId);
        user.location = index;
        common.save.saveGame();


        if (common.location.challenge)
        {
            this.playWeeklyChallengeVO();
        }

        console.log("location", common.locationIndex, common.location);
    }

    onCharacterSelectorSelect(selector, id, data) {
        this._weaponReveal = false;
        this.setCharacter(data.skin);

        this._characterInfo.nameLabel.text = data.name;
    }

    onCharacterSelectorItem(selector, id, slot, type) {
        this.setItem(slot, type);

        if (Math.random() < 0.4) {
            P3.audio.playVO([
                "vo_queen_36a",
                "vo_queen_37a",
                "vo_queen_38a",
                "vo_queen_39a"
            ]);
        }
    }

    playWeeklyChallengeVO()
    {
        if (!common.save.isWeeklyChallengeComplete(common.userId))
        {
            P3.audio.playVO("vo_queen_extra_15a", 1, true);
            return;
        }

        if (this._weeklyChallengeVO)
        {
            this._weeklyChallengeVO.destroy();
            this._weeklyChallengeVO = null;
        }

        let name;

        const days = 7 - common.weekday;
        switch (days)
        {
            case 1:
            {
                name = "vo_queen_extra_18a";
                break;
            }
            case 2:
            {
                name = "vo_queen_extra_19a";
                break;
            }
            case 3:
            {
                name = "vo_queen_extra_20a";
                break;
            }
            case 4:
            {
                name = "vo_queen_extra_21a";
                break;
            }
            case 5:
            {
                name = "vo_queen_extra_22a";
                break;
            }
            case 6:
            {
                name = "vo_queen_extra_23a";
                break;
            }
            case 7:
            {
                name = "vo_queen_extra_24a";
                break;
            }
        }

        this._weeklyChallengeVO = P3.audio.playVO("vo_queen_extra_17b1", 1, true);
        if (this._weeklyChallengeVO)
        {
            this._weeklyChallengeVO.signals.end.once(() =>
            {
                this._weeklyChallengeVO = P3.audio.playVO(name, 1, true);
                if (this._weeklyChallengeVO)
                {
                    this._weeklyChallengeVO.signals.end.once(() =>
                    {
                        this._weeklyChallengeVO = P3.audio.playVO("vo_queen_extra_17b2", 1, true);
                    });
                }
            });
        }
    }

    get editCharacter()
    {
        return this._editCharacter;
    }

    get characterSelector()
    {
        return this._characterSelector;
    }
}

OverviewScene.PAGE_CHARACTER = "character";
OverviewScene.PAGE_ITEM = "item";